import { where } from 'firebase/firestore';
import { fetchByTable, addDataToTable } from '../utils';

export const fetchFieldsByPlaceId = async (id, setLoading) =>
  fetchByTable({
    tableName: 'fields',
    whereCondition: where('placeId', '==', id),
    setLoading,
  });

export const fetchFieldsByUserId = async (id, setLoading) =>
  fetchByTable({
    tableName: 'fields',
    whereCondition: where('userId', '==', id),
    setLoading,
  });

export const addField = async (field, setLoading) =>
  addDataToTable({ tableName: 'fields', data: field, setLoading });
